<template>
  <div class="leads">
    <gnetHeader
        v-on:add="addCustomer"
        v-bind:actionAdd="true"
        v-bind:showTicket="true"
        v-on:ticket="editTicket=true"
    ></gnetHeader>

    <gnetTabBar
      v-bind:titoloapp="$store.getters.appname"
      v-bind:tabs="$store.state.tabs"
      v-bind:active_tab="$store.state.active_tab"
      v-on:click="changeTab($event)"
    />

    <gnet-card v-bind:title="'Clienti'" v-bind:object="'account'" v-bind:actions="headlineActions" v-on:click="actionClick($event)" v-bind:nospace="false">
    </gnet-card>

    <gnetTable
      v-bind:cols="cols"
      v-bind:records="records"
      v-on:click="gotoRecord($event)"
      v-on:change="campChange($event)"
      v-on:filter="filter($event)"
      v-on:sort="changeSort($event)"
    >      
    </gnetTable>

    <gnetModal
      v-if="filterPanel.show"
      v-bind:title="'Applica filtro'"
      v-bind:object="'lead'"
      v-on:cancel="filterPanel.show=false"
      v-on:submit="doFilter"
    >
        <label class="slds-form-element__label" v-bind:for="'form-element-1'">{{filterPanel.name}}</label>

        <div class="slds-form-element__control">
          <input v-model="filterPanel.value" type="text" id="form-element-2" placeholder="filtro..." class="slds-input" />
        </div>
    </gnetModal>

    <qualifica v-if="showQualifica" v-bind:newcustomer="true" v-bind:dati="dati" v-on:cancel="showQualifica=false" v-on:change="setField($event)" v-on:submit="createAccount" ></qualifica>

    <gnetTicket v-bind:fields="ticketfields" v-show="editTicket" v-on:change="setTicketField($event)" v-on:submit="saveTicketFd" v-on:cancel="editTicket=false" />

    <gnetSpinner v-bind:busy="busy"></gnetSpinner>

  </div>
</template>

<script>
// @ is an alias to /src
// import numeral from 'numeral'
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
import gnetTable from '../components/table.vue'
import gnetModal from '../components/modal.vue'
import gnetCard from '../components/card.vue'
import gnetTicket from '../components/ticket.vue'
import gnetSpinner from '../components/spinner.vue'
import apiclient from '@/apiclient.js'
import gnetMixLib from '@/mixin.js'
import qualifica from '../components/qualifica.vue'
//import numeral from 'numeral'
import moment from 'moment'
import mustache from 'mustache'

export default {
  name: 'Customers',
  mixins: [gnetMixLib],
  components: {
    gnetHeader,
    gnetTabBar,
    gnetTable,
    gnetSpinner,
    gnetTicket,
    gnetModal,
    gnetCard,
    qualifica
  },
  data: function() {
    return {
      tsi:0,
      tno:0,
      tupd:{},
      referente:'',
      editTicket: false,
      editTask: false,
      busy: false,
      cols: [],
      records: [],
      ordini: [],
      mCustomers:{},
      ticketfields:[],
      sortedcol: -1, 
      fieldsstring: '',
      filterPanel: {
        show: false,
        value:'',
        name:'',
        index:0,
        filterCol: {}
      },
      inattivi: {title: 'Mostra clienti inattivi', name:'Mostra clienti inattivi', symbol:''},
      attivi: {title: 'Nascondi clienti inattivi', name:'Nascondi clienti inattivi', symbol:''},
      headlineActions: [  ],

      showQualifica: false,

      dati: {
        Name:'',
        Codice_Subentro__c:'',
        Insegna__c:'',

        BillingStreet:'',
        BillingCity:'',
        BillingPostalcode:'',
        BillingState:'',

        Referente__c:'',
        Phone:'',
        Fax:'',
        Email__c:'',

        P_Iva__c:'',
        IBAN__c:'',
        Codice_Fatturazione_Elettronica__c:'',
        PEC__c:'',

        Spedire__c:'',
        ShippingStreet:'',
        ShippingCity:'',
        ShippingPostalcode:'',
        ShippingState:'',

        Referente_Consegne__c:'',
        Orari__c:'',

        Tipologia__c:'',
        Ubicazione__c:'',
        Contratto__c:'',
        Competitors__c:'',
        Description:''
      }

    };
  },
  created: function() {
  },
  mounted: function() {
    this.tupd=new Map();
    this.ticketfields=[];
    var t1={ id:1, title:'Destinatario', value:'', name:'Tipo', type:'picklist', placeholder:'Destinatario...', tabindex:1, disabled: false,
      options:[
        { label: 'Customer Service', value: 'Customer Service'},
        { label: 'Credito', value: 'Credito'},
      ]
    };
    this.ticketfields.push(t1);
    var f1={ id:2, title:'Oggetto', value:'', name:'Oggetto', type:'text', placeholder:'Oggetto...', tabindex:2, disabled: false};
    var f2={ id:3, title:'Descrizione', value:'', name:'Descrizione', type:'textarea', placeholder:'Descrizione...', tabindex:3, disabled: false};
    this.ticketfields.push(f1);
    this.ticketfields.push(f2);

    if (this.$store.state.connection.userdata.capoarea) {
      var f3={ id:4, title:'Informa Capoarea', value:'', name:'capoarea', type:'checkbox', placeholder:'Descrizione...', tabindex:4, disabled: false};
      this.ticketfields.push(f3);
    }

    this.setupRecordFields();
    this.getRecords();

    if (this.$store.state.showInactive)
      this.headlineActions.push(this.attivi);
    else
      this.headlineActions.push(this.inattivi);
  },
  computed: {
    actualdealer: function() {
      if (this.$store.state.multizona) 
        return this.$store.getters.zona;
      else
        return '';
    },
    campagna() {
      return this.$store.state.campagne.findIndex( c => c == '2027 PW')
    },
    campagna2() {
      return this.$store.state.campagne.findIndex( c => c == '2026 MO')
    }
  },
  watch: {
    actualdealer: function() {
      this.getRecords();
    }
  },
  methods: {
    createTicketNew: function() {
      var self=this;
      return new Promise(function(resolve, reject) {
        var hsdata= [
          { "name": "subject", "value": self.ticketfields[1].value },
          { "name": "content", "value": self.ticketfields[2].value },
          { "name": "hs_pipeline", "value": "0" },
          { "name": "hs_pipeline_stage", "value": "1" }
        ];

        // var referente=self.record.Referente_CC__c;
        // if (self.ticketfields[0].value=="Credito") referente=self.record.Referente_CR__c;

        self.referente="raffaella.gamberini@fcp.it";
        var capoarea=self.$store.state.connection.userdata.capoarea;
        if (self.ticketfields[0].value=="Credito") {
          self.referente="gabriele.pellegrino@fcp.it";
          if (capoarea=="andrea.quaggia@fcp.it") self.referente="chiara.micheli@fcp.it"; // 1W
          if (capoarea=="andrea.bernabe@fcp.it") self.referente="chiara.micheli@fcp.it"; // 1E
          if (capoarea=="gianluca.paoli@fcp.it") self.referente="nicola.pettazzoni@fcp.it"; // N2
          if (capoarea=="giuseppe.martusciello@fcp.it") self.referente="nicola.pettazzoni@fcp.it"; // S2
          if (capoarea=="domenico.depace@fcp.it") self.referente="lidia.selleri@fcp.it"; // 3
          if (capoarea=="sergio.fornario@fcp.it") self.referente="lidia.selleri@fcp.it"; // 4

        } else {

          self.referente="raffaella.gamberini@fcp.it";

          // if (capoarea=="claudio.minnocci@fcp.it") self.referente="elena.summo@fcp.it"; // 1          
          if (capoarea=="andrea.quaggia@fcp.it") self.referente="stefania.carrara@fcp.it"; // 1W
          if (capoarea=="andrea.bernabe@fcp.it") self.referente="stefania.carrara@fcp.it"; // 1E
          if (capoarea=="gianluca.paoli@fcp.it") self.referente="giulia.priolo@fcp.it"; // N2
          if (capoarea=="giuseppe.martusciello@fcp.it") self.referente="giulia.priolo@fcp.it"; // S2
          if (capoarea=="domenico.depace@fcp.it") self.referente="barbara.manaresi@fcp.it";  // 3
          if (capoarea=="sergio.fornario@fcp.it") self.referente="barbara.manaresi@fcp.it";  // 4

          if (self.$store.state.user.email=="claudio.minnocci@fcp.it") self.referente="michela.bernardi@fcp.it";
          if (self.$store.state.user.email=="massimino.liberatore@fcp.it") self.referente="michela.bernardi@fcp.it";
          if (self.$store.state.user.email=="michele.depace@fcp.it") self.referente="michela.bernardi@fcp.it ";
          if (self.$store.state.user.email=="marco.frau@fcp.it") self.referente="michela.bernardi@fcp.it";
          if (self.$store.state.user.email=="federico.massai@fcp.it") self.referente="michela.bernardi@fcp.it";
          if (self.$store.state.user.email=="stefano.novelli@fcp.it") self.referente="michela.bernardi@fcp.it";
          if (self.$store.state.user.email=="costantino.battista@fcp.it") self.referente="michela.bernardi@fcp.it";
          if (self.$store.state.user.email=="giuseppe.martusciello@fcp.it") self.referente="michela.bernardi@fcp.it";
          if (self.$store.state.user.email=="gianluca.paoli@fcp.it") self.referente="michela.bernardi@fcp.it";
          // if (self.$store.state.user.email=="emidio.marconi@fcp.it") self.referente="elena.summo@fcp.it";
          // if (self.$store.state.user.email=="amerigo.lizzani@fcp.it") self.referente="elena.summo@fcp.it";
          if (self.$store.state.user.email=="emidio.marconi@fcp.it") self.referente="michela.bernardi@fcp.it";
          if (self.$store.state.user.email=="amerigo.lizzani@fcp.it") self.referente="michela.bernardi@fcp.it";

        }
        var referente=self.referente;
        // hsdata.push( { "name": "nome_cliente", "value": self.record.Ragione_Sociale__c } );
        // hsdata.push( { "name": "codice_cliente", "value": self.record.Codice_2019__c } );

        console.log('apre un ticket con referente cc='+referente);
        if (referente=='ptorric@gnet.it') hsdata.push( { "name": "hubspot_owner_id", "value": "48654570" } ); // paolo
        if (referente=='ecornale@gnet.it') hsdata.push( { "name": "hubspot_owner_id", "value": "48900588" } ); // elena
        // credito
        if (referente=='gabriele.pellegrino@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179559" } );

        if (referente=='chiara.micheli@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179570" } );
        if (referente=='lidia.selleri@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179782" } );
        if (referente=='nicola.pettazzoni@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179578" } );

        // customer service
        if (referente=='raffaella.gamberini@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179378" } );

        if (referente=='carlotta.stegani@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "54197514" } );
        if (referente=='francesca.lepera@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179408" } );
        if (referente=='susanna.scarano@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "54197687" } );
        if (referente=='margherita.manfroi@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "54197685" } );
        if (referente=='giulia.priolo@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "54080383" } );
        if (referente=='elena.summo@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179381" } );
        if (referente=='barbara.manaresi@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179263" } );

        if (referente=='stefania.carrara@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "86870582" } );
        if (referente=='michela.bernardi@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "86871691" } );
      
        console.log('newTicket')
        console.log(hsdata);

        // resolve();
        apiclient.newTicket( self.$store.getters.connection, self.$store.getters.connection.userdata.hubspotId, 4070653709, hsdata ).then(function(resp) {
          console.log(resp);
          self.ticketLastCreated=resp.data;
          resolve();
        }).catch(function(err) {
          reject(err);
        });
      });
    },
    createTicketNewFd: function() {
      var self = this
      return new Promise((resolve, reject) => {
        var payload = {
          email: self.$store.getters.connection.email,
          subject: self.ticketfields[1].value,
          description: self.ticketfields[2].value,
          //company_id: 4070653709,
          priority: 1,
          status: 2,
          type: self.ticketfields[0].value
        }

        if(payload.email == 'ptorric@gnet.it') payload.email = 'ptorric@tsc4.com'

        var contactId = self.$store.getters.connection.userdata.contactId

        console.log("creating new ticket freshdesk...: " + contactId)

        apiclient.newTicketFd(self.$store.getters.connection, payload, contactId).then(response => {
          console.log("new freshdesk ticket sent")
          console.log(response)
          resolve(response)
        }).catch(error => {
          console.log("error sending new ticket freshdesk")
          alert(JSON.stringify(error))

          reject(error)
        })
      })
    },
    changeSort: function(icol) {
      console.log('changeSort:'+icol)
      if (this.sortedcol!=icol) {
        if (this.sortedcol>=0) this.cols[this.sortedcol].sortdir='';
      }
      this.sortedcol=icol;
      if (this.cols[icol].sortdir=='asc' || !this.cols[icol].sortdir) { this.cols[icol].sortdir='desc'; this.doSort(icol, 'desc'); return; }
      if (this.cols[icol].sortdir=='desc' ) { this.cols[icol].sortdir='asc'; this.doSort(icol, 'asc'); return; }
    },
    doSort: function(icol,dir) {
      console.log('sorting'+icol+dir);
      var self=this;
      var vdir=(dir=='desc'?-1:1);
      this.records.sort(function(a, b) {
        var va=a[self.cols[icol].name];
        var vb=b[self.cols[icol].name];
        if (self.cols[icol].name=="Campagne__c") {
          va=(va?va.split(';').length:0);
          vb=(vb?vb.split(';').length:0);
        }
         if(vb>va) return -1*vdir;
         if(vb<va) return 1*vdir;
        return 0;
      });
    },
    saveTicket: function() {
      console.log('saveTicket')
      var self = this;
      this.editTicket=false;
      self.createTicketNew().then(function() {
        console.log('ticket creato');
        self.sendEmail();
      })
    },
    saveTicketFd: function() {
      var self = this
      this.editTicket = false
      self.createTicketNewFd().then(function() {
        console.log("Ticket saved!")
        //self.getTimeline()
      })
    },
    setTicketField: function(e) {
      var index=e.name;
      var value=e.value;
      console.log('setField:'+index+'='+value)
      this.ticketfields[index].value=value;
    },
    sendEmail: function() {
      var ticket={ Subject: this.ticketfields[1].value, Body: this.ticketfields[2].value}
      var view={ Account: this.record, Ticket: ticket, User: this.$store.state.user.email }
      view.ticketUrl='https://app.hubspot.com/contacts/7900902/ticket/'+this.ticketLastCreated.objectId;
      view.ticketObj=this.ticketLastCreated;

      console.log('view');
      console.log(view);
      var tmplSubject='Ticket da {{User}} su {{{ Account.Name }}}: {{ Ticket[0].value }}';
      var tmplBody='<h1>Agente: {{User}}</h1>';
      tmplBody+='<h3>Codice Zona: {{Account.Zona_2__c}}</h3>';
      tmplBody+='<h3>Codice Agente: {{Account.Zona_1__c}}</h3>';
      tmplBody+='<h1>Cliente: {{Account.Name}}</h1>';
      tmplBody+='<h3>Link: <a href="{{ticketUrl}}">Clicca qui per vedere il ticket #{{ticketObj.objectId}}</a></h3>';
      tmplBody+='<h2>Oggetto: {{Ticket.Subject}}</h2>';
      tmplBody+='<p>{{Ticket.Body}}</p>';

      var to='ptorric@gnet.it'
      to=this.referente;

      var email={
        from:'salespaddy@tsc4.com',
        to: [to],
        bcc: ['ptorric@gnet.it','ecornale@gnet.it'],
        subject: mustache.render(tmplSubject, view),
        htmlbody: mustache.render(tmplBody, view),
      }

      email.cc=[this.$store.state.user.email];

      if (this.$store.state.connection.userdata.capoarea) {
        if (this.ticketfields[3].value) {
          email.cc.push(this.$store.state.connection.userdata.capoarea);
        }
      }
      console.log('email');
      console.log(email);
      
      apiclient.notify(this.$store.getters.connection, email).then(function(res) {
        console.log(res);
      }).catch(function(err){
        console.log(err);        
      })
      
    },
    saveTask: function(event) {
      console.log(event);
      var body={ WhatId: '', Subject: event.Tipo, Causale__c: event.Causale, Description: event.Descrizione, Utente__c: this.$store.state.user.email, Status: 'Completata', ActivityDate: new Date() };
      var self=this;
      apiclient.newTask(this.$store.getters.connection, body).then(function() {
        self.editTask=false;
        self.getTimeline();
      }).catch(function() {
        self.editTask=false;
      })
    },
    actionClick: function(e) {
      console.log(e);
      switch (e) {
        case 'Mostra clienti inattivi':
          this.headlineActions.pop();
          this.headlineActions.push(this.attivi);
          this.$store.commit('SET_INACTIVE', true);
          this.busy=true;
          this.getRecords();
        break;
        case 'Nascondi clienti inattivi':
          this.headlineActions.pop();
          this.headlineActions.push(this.inattivi);
          this.$store.commit('SET_INACTIVE', false);
          this.busy=true;
          this.getRecords();
        break;
      }
    },
    fixObject: function() {
      var o={};
      for (var f in this.dati) {
        if (this.dati[f]) o[f]=this.dati[f];
      }
      return o;
    },
    createAccount: function() {
      console.log('createAccount')
      var record=this.fixObject();
      record.Zona_1__c=this.$store.getters.zona;
      record.Fonte__c='FCP';
      record.Data_Ultima_Modifica_da_Utente__c=new moment().format('YYYY-MM-DD')
      record.Utente__c=this.$store.state.user.email;
      apiclient.create(this.$store.getters.connection, 'Account', record).then(function(data) {
        console.log(data);
      }).catch(function(err){
        console.log(err);
      })

      this.showQualifica=false;
    },
    setField: function(e) {
      console.log(e)
      var n=e.name;
      var v=e.value;
      var n2=n.substr(n.indexOf(".")+1)
      this.dati[n2]=v;
    },
    addCustomer: function() {
      this.showQualifica=true;
    },
    doFilter: function() {
      var col=this.cols[this.filterPanel.index];
      col.filtered=this.filterPanel.value;
      this.filterPanel.show=false;
      this.getRecords();
    },
    filter: function(index) {
      console.log('filtercc');
      var col=this.cols[index];
      if (col.filtered) {
        col.filtered=false;
        col.filterValue='';
        this.getRecords();
      } else {
        this.filterPanel.index=index;
        this.filterPanel.name=col.label;
        this.filterPanel.filterCol=col;
        this.filterPanel.value='';
        this.filterPanel.show=true;
      }
    },
    calcolaTotali: function() {
      this.tsi=0;
      this.tno=0;
      this.records.forEach(function(r) {
        if (r.Info_Campagne__c) {
          if (r.Info_Campagne__c.includes('RESI')) {
            if(r.ordinatoap) this.tsi+=r.ordinatoap;
          }
          if (r.Info_Campagne__c.includes('RENO')) {
            if(r.ordinatoap) this.tno+=r.ordinatoap;
          }
        }
      },this);
      // var c=this.cols[8];
      // c.label='Ordini '+this.$store.state.campagne[10]+'<br/>SI='+numeral(this.tsi).format('$ 0,0.00')+'<br/>NO='+numeral(this.tno).format('$ 0,0.00');
    },
    getOrdiniBQ: function() {
      var anno_cc=this.$store.state.campagne[this.campagna].substr(0,4);
      var cc=this.$store.state.campagne[this.campagna].substr(5,2);
      var sql='';
      sql='SELECT custaccount, nome_cliente, sum(qty) as tot_qty, round(sum(totale_no_oma),2) as tot_ordinato  '
      sql+='FROM `fcpanini-208106.ax.20200511__ordini_con_prodotti`  '
      sql+="where cc like '"+cc+"' and anno_cc ="+anno_cc+" and zona1 like '"+this.$store.getters.zona+"' ";
      sql+='group by custaccount, nome_cliente '
      sql+='order by nome_cliente'
      console.log(sql);
      var self=this;
      apiclient.getBQ(this.$store.getters.connection, sql).then(function(records) {
        self.ordini=records;
        self.ordini.forEach(function(c) {
          if (self.mCustomers.has(c.custaccount) ) {
            var i=self.mCustomers.get(c.custaccount);
            self.$set(self.records[i], 'ordinatocorrente', c.tot_ordinato);
          }
        });
        self.enableForecast();

        self.busy=false;
      });
    },
    getOrdiniBQAP: function() {
      var anno_cc=this.$store.state.campagne[this.campagna2].substr(0,4);
      var cc=this.$store.state.campagne[this.campagna2].substr(5,2);
      var sql='';
      sql='SELECT custaccount, nome_cliente, sum(qty) as tot_qty, round(sum(totale_no_oma),2) as tot_ordinato  '
      sql+='FROM `fcpanini-208106.ax.20200511__ordini_con_prodotti`  '
      sql+="where cc like '"+cc+"' and anno_cc ="+anno_cc+" and zona1 like '"+this.$store.getters.zona+"' ";
      sql+='group by custaccount, nome_cliente '
      sql+='order by nome_cliente'
      console.log(sql);
      var self=this;
      apiclient.getBQ(this.$store.getters.connection, sql).then(function(records) {
        self.ordiniAP=records;
        self.ordiniAP.forEach(function(c) {
          if (self.mCustomers.has(c.custaccount) ) {
            var i=self.mCustomers.get(c.custaccount);
            self.$set(self.records[i], 'ordinatoap', c.tot_ordinato);
          }
        });
        self.calcolaTotali();
        self.busy=false;
      });
    },    
    getRecords: function() {
      var self=this;
      var filtri=[];
      this.cols.forEach(function(d){
        if (d.filtered)
          filtri.push(d.name+' like \''+d.filtered+'%\'');
      });
      var soql='select '+this.fieldsstring+' from Account';

      if (this.$store.state.showInactive)
        filtri.push('( tipoAccount__c=\'Lead\' or tipoAccount__c=\'Inactive\' or tipoAccount__c=\'Bloccato\' ) ');
      else
        filtri.push('tipoAccount__c=\'Customer\'');

      filtri.push('Zona_1__c=\''+this.$store.getters.zona+'\'');

      var swhere=' where '+filtri.join(' and ');
      if (filtri.length>0)
        soql=soql+swhere;
      soql+=' order by Ragione_Sociale__c limit 1500';
      console.log(soql);
      apiclient.query(this.$store.getters.connection, soql).then(function(data) {
        console.log('records:'+data.length);
        self.records=data;
        self.enableForecast();
        self.busy=false;
        self.mCustomers=new Map();
        self.records.forEach(function(c,i) {
          self.mCustomers.set(c.Codice_2019__c,i);
          self.$set(c, 'ordinatocorrente', '');
          self.$set(c, 'ordinatoap', '');
        });
        self.getOrdiniBQ();
        self.getOrdiniBQAP();
      }).catch(function(err){
        console.log(err);
      })
    },
    enableForecast: function(all) {
      this.records.forEach(function(r) {
        if (!all)
          if (r.ordinatocorrente)
            this.$set(r, 'forecastdisabled', true);
          else
            this.$set(r, 'forecastdisabled', false);
        else
          this.$set(r, 'forecastdisabled', true);
      }, this)
    },
    getPicklistMap: function(v) {
      var l=(v?v.split(';'):[]);
      var m=new Map();
      l.forEach(function(d) {
        m.set(d.substr(0,2), d.substr(2,2) );
      });
      return m;
    },
    getMapPicklist: function(v) {
      var l=[]
      for (let [key, value] of v) {
        l.push(key+value);
      }
      return l;
    },
    campChange: function(e) {
      console.log(JSON.stringify(e,null, 2));
      var r=this.records[e.index];
      var vold=r[e.name];
      if (vold<0 && e.value<0) e.value='';

      this.$set(this.records[e.index],e.name,e.value);

      /*
      var m=this.getPicklistMap(v);
      console.log(m);
      m.set(e.value.substr(0,2), e.value.substr(2,2) );
      v=this.getMapPicklist(m);
      console.log(v);
      e.record[e.name]=v.join(';');
      */
      if (this.tupd.has(r.Id)) {
        clearTimeout(this.tupd.get(r.Id));
      }
      this.calcolaTotali();
      var self=this;
      this.tupd.set(r.Id,setTimeout(function() {
          self.updateAccount(r, e.name);
        }, 1000)
      );
    },
    updateAccount: function(record, name) {
      console.log('updateAccount')
      var mydata={};
      // mydata.Id=record.Id;
      mydata[name]=record[name];
      console.log(mydata);
      // this.busy=true;
      var self=this;
      apiclient.update(this.$store.getters.connection, 'Account', record.Id, mydata).then(function(data) {
        self.busy=false;
        console.log(data);
      }).catch(function(err){
        self.busy=false;
        alert(err);
        console.log(err);
      })
      
    },
    gotoRecord: function(record) {
      console.log(record);
      this.$router.push({ name:'CustomerForm', params: { id: record.Id, record: record } });
    },
    setupRecordFields: function() {
      // Protocollo, fase, funzionario, assistente, CST, data apertura mandato
      var ord=1;
//      this.cols.push( { order: ord++, value:'', label:'Prot.', name:'Name', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Ragione Sociale.', name:'Ragione_Sociale__c', type:'truncate', issortable: true, sortdir:'' } );
      this.cols.push( { order: ord++, value:'', label:'Indirizzo', name:'BillingStreet', type:'truncate' } );
      this.cols.push( { order: ord++, value:'', label:'Città', name:'BillingCity', type:'string', issortable: true, sortdir:'' } );
      this.cols.push( { order: ord++, value:'', label:'Codice Cliente', name:'Codice_2019__c', type:'string', issortable: true, sortdir:'' } );
      // this.cols.push( { order: ord++, value:'', label:'Info', name:'alert__c', type:'alert' } );
      this.cols.push( { order: ord++, value:'', label:'Info', name:'Campagne__c', type:'camp', options:[ 'P2', 'S2', 'N2', 'R2', 'M2', 'P1', 'S1', 'N1', 'R1', 'M1', 'PW', 'SC', 'NA', 'RE', 'MO'], issortable: true, sortdir:'' } );
      this.cols.push( { order: ord++, value:'', label:'R.I.S.A.', name:'Risa__c', type:'text', issortable: true, sortdir:'' } );
      this.cols.push( { order: ord++, value:'', label:'Ultimo Ordine', name:'Data_Ultimo_Ordine_AX__c', type:'date', issortable: true, sortdir:'' } );
      this.cols.push( { order: ord++, value:'', label:'Affiliazioni', name:'Affiliazioni_Status__c', type:'mix', issortable: true, sortdir:'', disabled:false } );
//      this.cols.push( { order: ord++, value:'', label:'Note Eastpak', name:'Note_Eastpak__c', type:'input3', issortable: true, sortdir:'', disabled:false } );
//      this.cols.push( { order: ord++, value:'', label:'NO Ordini', name:'Previsione__c', type:'input', issortable: true, sortdir:'', disabled:false } );
      this.cols.push( { order: ord++, value:'', label: 'Ordini '+this.$store.state.campagne[this.campagna], name:'ordinatocorrente', type:'currency', issortable: true, donotload:true } );
      this.cols.push( { order: ord++, value:'', label: 'Ordini '+this.$store.state.campagne[this.campagna2], name:'ordinatoap', type:'currency', issortable: true, donotload:true } );
      this.cols.push( { order: ord++, value:'', label:'Ordini AC', name:'Totale_Ordinato_AX__c', type:'currency', issortable: true, sortdir:'' } );
      this.cols.push( { order: ord++, value:'', label:'Ultima Attività', name:'LastActivityDate', type:'date' } );
      // this.cols.push( { order: ord++, value:'', label:'Stato Attivazione B2B', name:'Stato_Attivazione_B2B__c', type:'string' } );

      var mfields=new Map();
      mfields.set('Id', null);
      this.mapFields(mfields, this.cols);
      this.fieldsstring=this.uniqueFields(mfields).join(',');

    }
  }
}
</script>
